module.exports = __webpack_public_path__ + "static/geometric-bg-02-e8e905695d3f2748c51d99749ef819ed.svg";